/**
 * JS mirror of the CSS theme tokens. Useful when a component needs to inline
 * a color (e.g. SVG fill) outside Tailwind classes.
 */
export const tokens = {
  brand: '#FFCC00',
  brandFg: '#0A0A0A',
  brandStrong: '#E6B800',
  bg: '#FAFAFA',
  fg: '#0A0A0A',
  surface: '#FFFFFF',
  muted: '#F4F4F5',
  mutedFg: '#52525B',
  border: '#E4E4E7',
  ring: '#FFCC00',
  success: '#16A34A',
  warning: '#EAB308',
  danger: '#DC2626',
} as const;

export type ThemeTokens = typeof tokens;
